export default function replaceNonDigit(val) {
  return val.replace(/[^0-9]/, "");
}
